export enum Mode {
  edit = 'edit',
  new = 'new',
}
